export const subNavDropMenuStyles = {
	// The Popover root/backdrop cover the full viewport and would otherwise block clicks on sibling nav items; only the Paper itself should be interactive.
	pointerEvents: 'none',
	'.MuiPaper-root': {
		pointerEvents: 'auto',
		backgroundColor: 'neutrals.white',
		boxShadow: '0 0 1rem rgba(0, 0, 0, 0.1)',
		borderRadius: '0',
		boxSizing: 'border-box',
		// The anchor's computed left/width can drift from the viewport edges (scrollbar width, containing-block quirks); force them flush.
		left: '0 !important',
		width: '100vw !important',
		maxWidth: '100vw !important',
	},
};

export const subNavMobileDropMenuStyles = {
	// Higher than the mobile hamburger Menu's z-index (theme.zIndex.modal) so the drill-down renders on top of it.
	zIndex: 1301,
	'.MuiDrawer-paper': {
		width: '100%',
		maxWidth: '100%',
		backgroundColor: 'neutrals.white',
		boxSizing: 'border-box',
	},
};

export const subNavGridStyles = {
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gap: '1.5rem',
	padding: '1.25rem 4.5rem 1.25rem 4.5rem',
};

export const subNavMobileGridStyles = {
	display: 'flex',
	width: '100%',
	gap: '2rem',
	flexDirection: 'column',
	justifyContent: 'stretch',
	alignItems: 'flex-start',
	padding: '2rem 0',
};

export const subNavMobileBackButtonWrapperStyles = {
	justifyContent: 'flex-start',
	alignItems: 'center',
	width: '100%',
	border: 'none',
	background: 'none',
	padding: '.5rem 1.25rem',
	cursor: 'pointer',
	textAlign: 'left',
	minWidth: 'fit-content',
};

export const subNavColumnsGridStyles = {
	gridColumn: 'span 2',
	columnCount: 2,
	columnGap: '2rem',
	rowGap: '2rem',
};

export const subNavContentTilesStyles = {
	display: 'flex',
	flexDirection: 'column',
	gap: '0.75rem',
	padding: { xs: '0 1.25rem', md: '0' },
};

export const mobileNavigationStyles = {
	display: 'flex',
	flexFlow: 'column nowrap',
	gap: '1.5rem',
};

export const getSubNavColumnStyles = () => ({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	gap: { xs: '0.75rem', md: '0' },
	breakInside: 'avoid',
});

export const getSubNavColumnTitleLinkStyles = () => ({
	marginBottom: '0',
	px: { xs: '1.25rem', md: '0' },
	py: { xs: '0.5rem', md: '0' },
	'.MuiTypography-root': {
		color: 'text.interactive',
		border: 'none',
		height: 'auto',
		textIndent: 0,
	},
});

export const getFeaturedLinkStyles = () => ({
	marginBottom: '0',
	padding: '0',
	px: { xs: '1.25rem', md: '0' },
	py: { xs: '0.5rem', md: '0' },
	'.MuiTypography-root': {
		fontWeight: { xs: 'inherit', md: 400 },
		border: 'none',
		height: 'auto',
		textIndent: 0,
	},
});

export const getSubNavLinkStyles = () => ({
	marginLeft: '0.75rem',
	px: { xs: '1.25rem', md: '0' },
	py: { xs: '0.5rem', md: '0' },

	'.MuiTypography-root': {
		fontWeight: { xs: 'inherit', md: 400 },
		color: 'text.interactive',
		border: 'none',
		height: 'auto',
		// NavigationLink's own mobile default (navItemStylesMobile) hardcodes a 3.25rem lineHeight on this element; reset it here.
		lineHeight: 'normal',
		textIndent: 0,
	},
});
